export const EMAIL = 'email';
export const USERNAME = 'username';
export const COMPANY_NAME = 'company_name';
export const COMPANY_SIZE = 'company_size';
export const TRADE = 'trade';
export const PAY_PERIOD_START = 'pay_period_start';
export const PAY_PERIOD_TYPE = 'pay_period_type';
export const OVERTIME_START = 'overtime_start';
export const BI_WEEKLY_PAY_PERIOD_DAY = 'bi_weekly_pay_period_day';
export const MONTHLY_DAY = 'monthly_day';
export const SEMI_MONTHLY_DAY_ONE = 'semi_monthly_day_one';
export const SEMI_MONTHLY_DAY_TWO = 'semi_monthly_day_two';
export const FIRST_NAME = 'first_name';
export const LAST_NAME = 'last_name';
export const PHONE = 'phone';
export const RESET_PASSWORD = 'reset_password';
export const VERIFY_EMAIL = 'verify_email';
export const INVITATION = 'invitation';
export const CODE = 'code';
export const REALM_ID = 'realmId';
export const TIME = 'time';
export const COLORS = 'colors';
export const PROJECT_ID = 'project_id';
export const PROJECT_GROUP_ID = 'project_group_id';
export const EMPLOYEE_GROUP_ID = 'employee_group_id';
export const EMPLOYEE_ID = 'employee_id';
export const COST_CODE_ID = 'cost_code_id';
export const COST_CODE_GROUP_ID = 'cost_code_group_id';
export const EQUIPMENT_ID = 'equipment_id';
export const EQUIPMENT_CATEGORY_ID = 'equipment_category_id';
export const UNSUBSCRIBE = 'unsubscribe';
export const TIME_RANGE_TYPE = 'time_range_type';
export const TIMESHEET_VIEW = 'timesheet_view';
export const TIMESHEET_REPORT_TYPE = 'timesheet_report_type';
export const TIMESHEET_GRAPH_TYPE = 'timesheet_graph_type';
export const START_DATE = 'start_date';
export const END_DATE = 'end_date';
export const TYPE = 'type';
export const FILTER_TYPE = 'filter_type';
export const SETTING = 'setting';
export const TIME_CARD_ISSUE = 'time_card_issue';
export const LOCATION_TYPE = 'location_type';
export const EMPLOYEES = 'employees';
export const PROJECTS = 'projects';
export const EQUIPMENT = 'equipment';
export const FILTER_STATUS = 'filter_status';
export const SIGNATURE_STATUS = 'signature_status';
export const POSITION_ID = 'position_id';
export const PROGRESS_VIEW_TYPE = 'progress_view_type';
export const REPORT_TYPE = 'report_type';
export const TIME_OFF_TYPE = 'time_off_type';
export const PAY_TYPE = 'pay_type';
export const ARCHIVED_STATUS = 'archived_status';
export const PRINT = 'print';
export const GRAPH_TYPE = 'graph_type';
export const SEARCH = 'search';
export const QUERY_PARAM_DATE_FORMAT = 'M-d-yyyy';
export const DATE_RANGE_LIMIT = 'date_range_limit';
export const WAGE_TYPE = 'wage_type';
export const TIMECARD_REPORT_VIEW = 'timecard_report_view';
export const TIME_ENTRY_STATE = 'time_entry_state';
export const ACCESS_TYPE = 'access_type';
export const DPR_TEMPLATE_ID = 'dpr_template_id';
export const PHOTO_TYPE = 'photo_type';
export const ACTION_TYPE = 'action_type';
export const PERFORMER_ID = 'performer_id';
export const CREATED_BY_ID = 'created_by_id';
export const FILE_TYPE = 'file_type';
export const SCHEDULED_STATUS = 'scheduled_status';
export const VIEW = 'view';
export const BULLETIN_FILTER_SETTING = 'bulletin_filter_setting';
export const ACTIVITY = 'activity';

export const QueryParam = {
  ARCHIVED_STATUS,
  ACTION_TYPE,
  ACTIVITY,
  EMAIL,
  USERNAME,
  COMPANY_NAME,
  COMPANY_SIZE,
  CREATED_BY_ID,
  TRADE,
  PAY_PERIOD_START,
  PAY_PERIOD_TYPE,
  OVERTIME_START,
  BI_WEEKLY_PAY_PERIOD_DAY,
  MONTHLY_DAY,
  SEMI_MONTHLY_DAY_ONE,
  SEMI_MONTHLY_DAY_TWO,
  FIRST_NAME,
  LAST_NAME,
  PHONE,
  RESET_PASSWORD,
  CODE,
  REALM_ID,
  TIME,
  PROJECT_ID,
  PROJECT_GROUP_ID,
  EMPLOYEE_GROUP_ID,
  EMPLOYEE_ID,
  COST_CODE_ID,
  COST_CODE_GROUP_ID,
  EQUIPMENT_ID,
  EQUIPMENT_CATEGORY_ID,
  UNSUBSCRIBE,
  VERIFY_EMAIL,
  INVITATION,
  TIME_ENTRY_STATE,
  TIME_RANGE_TYPE,
  TIMESHEET_VIEW,
  TIMESHEET_REPORT_TYPE,
  TIMESHEET_GRAPH_TYPE,
  START_DATE,
  END_DATE,
  COLORS,
  TYPE,
  FILTER_TYPE,
  SETTING,
  TIME_CARD_ISSUE,
  LOCATION_TYPE,
  PROJECTS,
  EMPLOYEES,
  EQUIPMENT,
  FILTER_STATUS,
  SIGNATURE_STATUS,
  POSITION_ID,
  PROGRESS_VIEW_TYPE,
  REPORT_TYPE,
  SCHEDULED_STATUS,
  TIME_OFF_TYPE,
  PAY_TYPE,
  PRINT,
  GRAPH_TYPE,
  SEARCH,
  QUERY_PARAM_DATE_FORMAT,
  DATE_RANGE_LIMIT,
  WAGE_TYPE,
  TIMECARD_REPORT_VIEW,
  ACCESS_TYPE,
  DPR_TEMPLATE_ID,
  PHOTO_TYPE,
  PERFORMER_ID,
  FILE_TYPE,
  VIEW,
  BULLETIN_FILTER_SETTING,
};
